export default __webpack_public_path__ + "static/media/RCFC_2021_STD_P_S1_OPEN.2d341ece.mp4";